var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBattery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.027,
    height: 37.829,
    viewBox: "0 0 49.027 37.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3521",
    "data-name": "Group 3521",
    transform: "translate(-18.877 -22.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613",
    transform: "translate(19.127 22.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    d: "M1.866,1.911V30.572H46.661V1.911H1.866M1.866,0H46.661a1.889,1.889,0,0,1,1.866,1.911V30.572a1.889,1.889,0,0,1-1.866,1.911H1.866A1.889,1.889,0,0,1,0,30.572V1.911A1.889,1.889,0,0,1,1.866,0Z",
    transform: "translate(0 4.846)",
    fill: "#525252",
    stroke: "#525252",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612",
    transform: "translate(9.495 12.935)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 6.314,
    height: 1.263,
    transform: "translate(0 2.525)",
    fill: "#525252",
    stroke: "#525252",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610",
    transform: "translate(22.73 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 1.263,
    height: 6.314,
    transform: "translate(2.525)",
    fill: "#525252",
    stroke: "#525252",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 6.314,
    height: 1.263,
    transform: "translate(0 2.525)",
    fill: "#525252",
    stroke: "#525252",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    d: "M1.615,1.615V4.846H9.692V1.615H1.615M1.615,0H9.692a1.615,1.615,0,0,1,1.615,1.615V4.846A1.615,1.615,0,0,1,9.692,6.462H1.615A1.615,1.615,0,0,1,0,4.846V1.615A1.615,1.615,0,0,1,1.615,0Z",
    transform: "translate(3.231)",
    fill: "#525252",
    stroke: "#525252",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    d: "M1.615,1.615V4.846H9.692V1.615H1.615M1.615,0H9.692a1.615,1.615,0,0,1,1.615,1.615V4.846A1.615,1.615,0,0,1,9.692,6.462H1.615A1.615,1.615,0,0,1,0,4.846V1.615A1.615,1.615,0,0,1,1.615,0Z",
    transform: "translate(32.373)",
    fill: "#525252",
    stroke: "#525252",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBattery);
export default __webpack_public_path__ + "static/media/icon_battery.a06d51fb49270a4c22f48d7468f722d8.svg";
export { ForwardRef as ReactComponent };